/**
 * React 19 compatibility shim for legacy packages (react-quill, react-datepicker)
 * that still import findDOMNode from react-dom.
 *
 * findDOMNode was removed in React 19. We provide a stub so the build succeeds.
 * These packages will be properly upgraded in Phase 5 of the upgrade plan.
 *
 * NOTE: We require 'react-dom/index.js' (NOT 'react-dom') to avoid circular
 * alias resolution – the webpack alias 'react-dom$' only matches the exact
 * string 'react-dom', not 'react-dom/index.js'.
 */
// '__react-dom-cjs__' is a webpack alias defined in craco.config.js that points
// to the absolute filesystem path of react-dom's CJS build. Using this alias:
//   1. Avoids triggering the 'react-dom$' circular alias (different key).
//   2. Bypasses react-dom's exports field restriction on './index.js'.
// eslint-disable-next-line import/no-unresolved
const ReactDOM = require('__react-dom-cjs__');

/**
 * findDOMNode stub. Handles the most common cases:
 * - null/undefined → null
 * - DOM elements → returns them directly
 * - Class component instances → returns null (safe fallback; these packages
 *   only use it for DOM manipulation which modern React handles via refs)
 */
function findDOMNode(componentOrElement) {
  if (componentOrElement == null) return null;
  // Already a DOM node (element or text node)
  if (componentOrElement.nodeType != null) {
    return componentOrElement;
  }
  return null;
}

module.exports = Object.assign({}, ReactDOM, { findDOMNode });
